"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var keycode = require("keycode");
var lodash_1 = require("lodash");
var React = require("react");
var KeycodeType;
(function (KeycodeType) {
    KeycodeType["Combo"] = "combo";
    KeycodeType["Numeric"] = "numeric";
    KeycodeType["Symbol"] = "symbol";
    KeycodeType["Alphabetic"] = "alphabetic";
})(KeycodeType || (KeycodeType = {}));
exports.removeHrefJavascriptUrl = function (href) {
    return href.trim().includes('javascript:') ? '#' : href;
};
/**
 * Tests to see if a react element is an instance of a component class.
 * Uses createElement because normal type checking will fail in a HMR environment.
 * This issue has not been fixed as of react-hot-loader@4.3.3
 *      https://github.com/gaearon/react-hot-loader/issues/304
 * @param element The react element to test.
 * @param componentType The react component class to match.
 * @returns {boolean} If the element matches the componentType.
 */
exports.isType = function (element, componentType) {
    return element != null && element.type === React.createElement(componentType).type;
};
/**
 * Collection of static functions to find substring matches.
 */
exports.FindText = {
    /**
     * Returns `true` if the searchText exists in the sourceText, `false`
     * otherwise.
     *
     * @param sourceText The text to search for a match in.
     * @param searchText The substring to search for in the sourceText.
     * @returns {boolean} If the searchText exists in the sourceText.
     */
    hasMatch: function (sourceText, searchText) {
        if (!sourceText) {
            return false;
        }
        if (!searchText) {
            return true;
        }
        return this.getMatchStartIndex(sourceText, searchText) !== -1;
    },
    /**
     * Returns a HTMLElement containing the sourceText, with a class added to
     * the searchText substring.
     *
     * @param sourceText The text to search for a match in.
     * @param searchText The substring to search for in the sourceText.
     * @returns {HTMLElement|string} The sourceText with highlighted searchText,
     *      or the sourceText.
     */
    highlightMatch: function (sourceText, searchText) {
        if (!searchText) {
            return sourceText;
        }
        var matchStartIndex = this.getMatchStartIndex(sourceText, searchText);
        if (matchStartIndex === -1) {
            return sourceText;
        }
        var matchEndIndex = matchStartIndex + searchText.length;
        return (React.createElement("span", null,
            sourceText.slice(0, matchStartIndex),
            React.createElement("span", { className: "highlight" }, sourceText.slice(matchStartIndex, matchEndIndex)),
            sourceText.slice(matchEndIndex)));
    },
    /**
     * Get the position of the first match of the searchText in the sourceText.
     *
     * @param sourceText The text to search for a match in.
     * @param searchText The substring to search for in the sourceText.
     * @returns {number} The index of the first match.
     */
    getMatchStartIndex: function (sourceText, searchText) {
        return sourceText.search(new RegExp(lodash_1.escapeRegExp(searchText), 'i'));
    },
};
/**
 * Collection of static functions used to check the type of a keyDown event.
 */
exports.KeyDown = {
    /**
     * Returns `true` if the `Ctrl`, `Meta`, or `Alt` keys are down.
     *
     * @param e The KeyboardEvent to check.
     * @returns {boolean} `true` if a combo key is down, `false` otherwise.
     */
    isCombo: function (e) {
        return e.ctrlKey || e.metaKey || e.altKey;
    },
    /**
     * Returns `combo` if a combination of keys are down, `numeric` or `symbol` rescectively
     *
     * @param e The KeyboardEvent to check
     * @returns {string} `combo`, `numeric`, `symbol`
     */
    getKeycodeType: function (e) {
        if (exports.KeyDown.isCombo(e)) {
            return KeycodeType.Combo;
        }
        if ((e.keyCode >= keycode('Numpad *') &&
            e.keyCode <= keycode('Numpad /')) ||
            (e.keyCode >= keycode(';') && e.keyCode <= keycode("'"))) {
            return KeycodeType.Symbol;
        }
        if ((e.keyCode >= keycode('0') && e.keyCode <= keycode('9')) ||
            (e.keyCode >= keycode('Numpad 0') &&
                e.keyCode <= keycode('Numpad 9'))) {
            return KeycodeType.Numeric;
        }
        if (e.keyCode >= keycode('a') && e.keyCode <= keycode('z')) {
            return KeycodeType.Alphabetic;
        }
    },
    /**
     * Returns `true` if the key is `a-z`, case insensitive.
     *
     * @param e The KeyboardEvent to check.
     * @returns {boolean} `true` if alphabetic, `false` otherwise.
     */
    isAlphabetic: function (e) {
        return exports.KeyDown.getKeycodeType(e) === KeycodeType.Alphabetic;
    },
    /**
     * Returns `true` if the key is `a-z` or `0-9`.
     *
     * @param e The KeyboardEvent to check.
     * @returns {boolean} `true` if alphanumeric, `false` otherwise.
     */
    isAlphanumeric: function (e) {
        return exports.KeyDown.isAlphabetic(e) || exports.KeyDown.isNumeric(e);
    },
    /**
     * Returns `true` if the key is `0-9`.
     *
     * @param e The KeyboardEvent to check.
     * @returns {boolean} `true` if numeric, `false` otherwise.
     */
    isNumeric: function (e) {
        return exports.KeyDown.getKeycodeType(e) === KeycodeType.Numeric;
    },
    /**
     * Returns `true` if the key is a symbol.
     *
     * @param e The KeyboardEvent to check.
     * @returns {boolean} `true` if a symbol, `false` otherwise.
     */
    isSymbol: function (e) {
        return exports.KeyDown.getKeycodeType(e) === KeycodeType.Symbol;
    },
    /**
     * Returns `true` if the key is alphanumeric or a symbol.
     *
     * @param e The KeyboardEvent to check.
     * @returns {boolean} `true` if a visible character, `false` otherwise.
     */
    isVisibleCharacter: function (e) {
        return exports.KeyDown.isAlphanumeric(e) || exports.KeyDown.isSymbol(e);
    },
};
//# sourceMappingURL=utils.js.map